import { ReactElement, ReactNode, cloneElement } from 'react';
import { defaultActions } from './constants';
import { ActionsColumn, Column } from './types';

const useCellRender = <DataModel,>() => {
	const defaultRender = (column: Column<DataModel>, item: DataModel): string =>
		column.accessors.map((accessor) => item[accessor]).join(' ');

	const renderTableCell = (column: Column<DataModel>, item: DataModel): ReactNode => {
		if (!column.render) return defaultRender(column, item);
		const renderProps = column.accessors.reduce(
			(props, currentAccessor) => ({
				...props,
				[currentAccessor]: item[currentAccessor],
			}),
			{} as Partial<DataModel>
		);

		return column.render(renderProps);
	};

	const renderActionsCell = (
		actionsColumn: ActionsColumn<DataModel>,
		item: DataModel
	): ReactElement | null => {
		if (!actionsColumn) return null;
		if (actionsColumn.render) return actionsColumn.render(item);
		if (actionsColumn.actions) {
			return (
				<>
					{actionsColumn.actions.map((action, key) => {
						if (action.permitted && !action.permitted(item)) return null;
						return cloneElement(defaultActions[action.type], {
							onClick: (event: MouseEvent) => {
								event.stopPropagation();
								action.callback(item);
							},
							key: `action-cell-${key}`,
						});
					})}
				</>
			);
		}

		return null;
	};

	return { renderTableCell, renderActionsCell };
};

export default useCellRender;
